var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArtificialIntelligence(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 102.06 113.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6{fill:none;}.cls-2,.cls-3,.cls-7,.cls-5,.cls-6{stroke:#fff;}.cls-2,.cls-7{stroke-miterlimit:10;}.cls-3,.cls-4{stroke-linecap:round;}.cls-3,.cls-4,.cls-5,.cls-6{stroke-linejoin:round;}.cls-4{stroke:#2280f8;}.cls-7{fill:rgba(255,255,255,.2);}.cls-8{fill:url(#radial-gradient);fill-opacity:.75;}.cls-5{stroke-linecap:square;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 82.11,
    cy: 54.82,
    fx: 82.11,
    fy: 54.82,
    r: 4.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52a2f6",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.94,11.82V98.62c.01,7.81-6.32,14.13-14.12,14.13-5.4,0-10.09-3.02-12.46-7.47-.33,.05-.67,.08-1.01,.09-6.7,.26-12.33-4.95-12.59-11.66-.02-.43-.01-.85,.02-1.26h-.02c-5.56,0-10.05-4.49-10.05-10.05,0-1.75,.46-3.41,1.26-4.84,.16-.3,.33-.59,.52-.87,.08-.12,.17-.24,.25-.35,1-1.3,2.3-2.36,3.81-3.05-.38-.09-.76-.18-1.13-.29-.28-.08-.56-.17-.84-.26C5.98,70.18,.5,63,.5,54.53c0-6.88,3.62-12.91,9.07-16.3,.73-.46,1.48-.86,2.26-1.2l-.09-.12c-.08-.11-.17-.23-.25-.35-.19-.28-.36-.57-.52-.87-.8-1.43-1.26-3.09-1.26-4.84,0-5.56,4.49-10.05,10.05-10.05h.02c-.03-.41-.04-.83-.02-1.26,.26-6.71,5.89-11.92,12.59-11.66,.34,.01,.68,.04,1.01,.09,1.8,.21,3.46,.81,4.92,1.73,.19-1.23,.59-2.39,1.16-3.44,1.83-3.43,5.44-5.76,9.61-5.76,6.02,0,10.9,4.88,10.9,10.9,0,.14,0,.28-.01,.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.47,7.69c2.19-5.02,5.61-7.18,9.78-7.18,6.02,0,10.9,4.88,10.9,10.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.33,30.85c0,.13,0,.26,.02,.38,0,.02,0,.05,0,.07,.08,.64,.34,1.23,.72,1.72,.05,.06,.09,.11,.14,.17,.04,.05,.09,.09,.14,.14,.14,.14,.29,.26,.44,.38,.57,.41,1.28,.65,2.04,.65,1.12,0,2.13-.53,2.77-1.35l.03-.04s.06-.08,.09-.12c.07-.1,.13-.2,.18-.3,.54-.96,.64-2.21,0-3.41-.59-1.13-1.81-1.8-3.09-1.8h0c-.63,0-1.23,.17-1.75,.48h-.02c-.96,.58-1.63,1.6-1.72,2.78,0,.08-.01,.17-.01,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M27.47,20.01c0,.16,0,.33,.03,.48,0,.03,0,.06,0,.08,.1,.81,.43,1.55,.9,2.16,.06,.07,.11,.14,.18,.21,.05,.06,.11,.12,.17,.18,.17,.17,.36,.33,.56,.47,.72,.51,1.61,.82,2.56,.82,1.41,0,2.67-.67,3.48-1.7l.04-.05s.07-.1,.11-.15c.08-.12,.16-.25,.23-.38,.35-.63,.55-1.36,.55-2.13,0-2.44-1.97-4.41-4.41-4.41h0c-.79,0-1.55,.22-2.2,.6h-.03c-1.21,.73-2.05,2.01-2.16,3.49,0,.11-.01,.22-.01,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.94,11.41v.41c0,.1-.01,.2-.02,.3,.01-.35,.02-.61,.02-.71Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 74,
    cy: 22.25,
    r: 2.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M56.74,29.99l-3.76-3.76c-2.06-2.06-4.6-3.56-7.37-4.48-.08-.03-.15-.05-.23-.08-.75-.27-1.46-.62-2.12-1.03-.23-.15-.46-.3-.69-.47-2.18-1.6-3.73-4-4.24-6.77-.13-.65-.19-1.31-.19-2,0-.38,.02-.74,.06-1.1,.14-1.45,.57-2.82,1.23-4.03,1.83-3.43,5.45-5.76,9.61-5.76,6.02,0,10.9,4.88,10.9,10.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "72.13 24.34 66.48 29.99 59.95 29.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M11.49,36.56c-.19-.28-.36-.57-.52-.87-.8-1.43-1.26-3.09-1.26-4.84,0-5.56,4.49-10.05,10.05-10.05h.02c1.81,0,3.53,.49,5,1.36,.02,0,.05,.02,.07,.03,2.75,1.63,4.66,4.54,4.91,7.91,0,.11,.02,.22,.02,.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.18,92.07c1.03,0,2.01-.18,2.92-.5,.6-.21,1.16-.49,1.69-.82,.18-.12,.37-.24,.55-.37,1.73-1.28,2.96-3.18,3.37-5.38,.1-.52,.15-1.04,.15-1.59,0-.3-.02-.59-.05-.88-.11-1.15-.45-2.24-.98-3.21"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 45.58,
    cy: 95.14,
    r: 3.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M52.83,79.31c-1.76-3.3-5.59-5.32-9.76-4.34s-6.77,4.78-6.55,8.9c.01,.24,.04,.48,.07,.71,0,.02,0,.04,.01,.06h0c.11,.78,.32,1.51,.62,2.2,.11,.25,.04,.54-.18,.71-2.62,2.07-4.48,5.05-5.12,8.48-.17,.84-.25,1.7-.25,2.59,0,.49,.03,.96,.08,1.43,.18,1.88,.74,3.65,1.6,5.23,2.37,4.45,7.06,7.47,12.46,7.47,7.8,0,14.13-6.32,14.13-14.13"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.61,54.55c0,.11,0,.21-.02,.32,0,.02,0,.04,0,.06-.07,.53-.28,1.02-.6,1.43-.04,.05-.08,.09-.12,.14-.03,.04-.08,.08-.11,.12-.11,.11-.24,.22-.37,.31-.48,.34-1.06,.54-1.69,.54-.93,0-1.76-.44-2.3-1.12l-.03-.03s-.05-.07-.07-.1c-.06-.08-.1-.17-.15-.25-.23-.41-.37-.9-.37-1.4,0-1.61,1.3-2.91,2.91-2.91h0c.52,0,1.02,.14,1.45,.39h.02c.8,.48,1.35,1.32,1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.58,47.17c1.98,1.92,3.16,4.65,3.04,7.63v.02c-.08,1.81-.64,3.51-1.57,4.94-.01,.02-.02,.05-.03,.07-.85,1.31-2.01,2.41-3.36,3.21"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.85,91.06s-.05,.02-.07,.03c-1.47,.87-3.19,1.36-5,1.36h-.02c-5.56,0-10.05-4.49-10.05-10.05,0-1.75,.46-3.41,1.26-4.84,.16-.3,.33-.59,.52-.87,.08-.12,.17-.24,.25-.35,1-1.3,2.3-2.36,3.81-3.05,1.28-.6,2.7-.93,4.21-.93"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 70.31,
    cy: 11.05,
    r: 2.81
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "85.33 30.85 76.05 30.85 64.2 42.7 59.95 42.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M89.64,77.65c0,.11,0,.21,.02,.32,0,.02,0,.04,0,.06,.07,.53,.28,1.02,.6,1.43,.04,.05,.08,.09,.12,.14,.03,.04,.08,.08,.11,.12,.11,.11,.24,.22,.37,.31,.48,.34,1.06,.54,1.69,.54,.93,0,1.76-.44,2.3-1.12l.03-.03s.05-.07,.07-.1c.06-.08,.1-.17,.15-.25,.46-.82,.53-1.9-.05-2.93-.5-.88-1.49-1.38-2.5-1.38h0c-.52,0-1.02,.14-1.45,.39h-.02c-.8,.48-1.35,1.32-1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.29,77.65c0,.11,0,.21,.02,.32,0,.02,0,.04,0,.06,.07,.53,.28,1.02,.6,1.43,.04,.05,.08,.09,.12,.14,.03,.04,.08,.08,.11,.12,.11,.11,.24,.22,.37,.31,.48,.34,1.06,.54,1.69,.54,.93,0,1.76-.44,2.3-1.12l.03-.03s.05-.07,.07-.1c.06-.08,.1-.17,.15-.25,.46-.82,.53-1.9-.05-2.93-.5-.88-1.49-1.38-2.5-1.38h0c-.52,0-1.02,.14-1.45,.39h-.02c-.8,.48-1.35,1.32-1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M93.61,45.61c0,.11,0,.21,.02,.32,0,.02,0,.04,0,.06,.07,.53,.28,1.02,.6,1.43,.04,.05,.08,.09,.12,.14,.03,.04,.08,.08,.11,.12,.11,.11,.24,.22,.37,.31,.48,.34,1.06,.54,1.69,.54,.93,0,1.76-.44,2.3-1.12l.03-.03s.05-.07,.07-.1c.06-.08,.1-.17,.15-.25,.46-.82,.53-1.9-.05-2.93-.5-.88-1.49-1.38-2.5-1.38h0c-.52,0-1.02,.14-1.45,.39h-.02c-.8,.48-1.35,1.32-1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.75,64.35c0,.11,0,.21,.02,.32,0,.02,0,.04,0,.06,.07,.53,.28,1.02,.6,1.43,.04,.05,.08,.09,.12,.14,.03,.04,.08,.08,.11,.12,.11,.11,.24,.22,.37,.31,.48,.34,1.06,.54,1.69,.54,.93,0,1.76-.44,2.3-1.12l.03-.03s.05-.07,.07-.1c.06-.08,.1-.17,.15-.25,.46-.82,.53-1.9-.05-2.93-.5-.88-1.49-1.38-2.5-1.38h0c-.52,0-1.02,.14-1.45,.39h-.02c-.8,.48-1.35,1.32-1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M93.78,47.17c-1.98,1.92-3.16,4.65-3.04,7.63v.02c.08,1.81,.64,3.51,1.57,4.94,.01,.02,.02,.05,.03,.07,.85,1.31,2.01,2.41,3.36,3.21"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 90.42,
    y1: 54.82,
    x2: 60.44,
    y2: 54.82
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.95,68.06h14.19c5.2,0,10.18,2.07,13.86,5.74l2.41,2.41"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 69.05,
    y1: 68.06,
    x2: 77.2,
    y2: 76.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 56.74,
    y1: 29.99,
    x2: 59.95,
    y2: 29.99
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.96,30.85c0,.08,0,.16-.01,.24,0,.02,0,.03,0,.04-.05,.4-.21,.78-.45,1.08-.03,.04-.06,.07-.09,.11-.03,.03-.06,.06-.09,.09-.09,.09-.18,.17-.28,.24-.36,.26-.81,.41-1.28,.41-.71,0-1.34-.33-1.74-.85l-.02-.03s-.04-.05-.06-.08c-.04-.06-.08-.13-.11-.19-.18-.31-.28-.68-.28-1.06,0-1.22,.99-2.21,2.21-2.21h0c.4,0,.78,.11,1.1,.3h.02c.61,.37,1.03,1.01,1.08,1.75,0,.05,0,.11,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.27,38.51c0,.11,0,.21-.02,.32,0,.02,0,.04,0,.06-.07,.53-.28,1.02-.6,1.43-.04,.05-.08,.09-.12,.14-.03,.04-.08,.08-.11,.12-.11,.11-.24,.22-.37,.31-.48,.34-1.06,.54-1.69,.54-.93,0-1.76-.44-2.3-1.12l-.03-.03s-.05-.07-.07-.1c-.06-.08-.1-.17-.15-.25-.23-.41-.37-.9-.37-1.4,0-1.61,1.3-2.91,2.91-2.91h0c.52,0,1.02,.14,1.45,.39h.02c.8,.48,1.35,1.32,1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.77,30.85c0,.11,0,.21-.02,.32,0,.02,0,.04,0,.06-.07,.53-.28,1.02-.6,1.43-.04,.05-.08,.09-.12,.14-.03,.04-.08,.08-.11,.12-.11,.11-.24,.22-.37,.31-.48,.34-1.06,.54-1.69,.54-.93,0-1.76-.44-2.3-1.12l-.03-.03s-.05-.07-.07-.1c-.06-.08-.1-.17-.15-.25-.23-.41-.37-.9-.37-1.4,0-1.61,1.3-2.91,2.91-2.91h0c.52,0,1.02,.14,1.45,.39h.02c.8,.48,1.35,1.32,1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M59.95,42.7h-7.63c-4.17,0-8.16-1.66-11.11-4.6l-2.81-2.81c-2.99-2.99-7.05-4.67-11.28-4.67h-4.48"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.3,
    y1: 38.51,
    x2: 34.27,
    y2: 38.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 49.04,
    cy: 11.05,
    r: 2.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 47.28,
    y1: 28.68,
    x2: 51.82,
    y2: 25.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 51.09,
    y1: 12.97,
    x2: 54.34,
    y2: 16.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 59.95,
    y1: 16.22,
    x2: 54.34,
    y2: 16.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.66,82.41c0,.11,0,.21-.02,.32,0,.02,0,.04,0,.06-.07,.53-.28,1.02-.6,1.43-.04,.05-.08,.09-.12,.14-.03,.04-.08,.08-.11,.12-.11,.11-.24,.22-.37,.31-.48,.34-1.06,.54-1.69,.54-.93,0-1.76-.44-2.3-1.12l-.03-.03s-.05-.07-.07-.1c-.06-.08-.1-.17-.15-.25-.23-.41-.37-.9-.37-1.4,0-1.61,1.3-2.91,2.91-2.91h0c.52,0,1.02,.14,1.45,.39h.02c.8,.48,1.35,1.32,1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M22.61,54.55c0,.11,0,.21-.02,.32,0,.02,0,.04,0,.06-.07,.53-.28,1.02-.6,1.43-.04,.05-.08,.09-.12,.14-.03,.04-.08,.08-.11,.12-.11,.11-.24,.22-.37,.31-.48,.34-1.06,.54-1.69,.54-.93,0-1.76-.44-2.3-1.12l-.03-.03s-.05-.07-.07-.1c-.06-.08-.1-.17-.15-.25-.23-.41-.37-.9-.37-1.4,0-1.61,1.3-2.91,2.91-2.91h0c.52,0,1.02,.14,1.45,.39h.02c.8,.48,1.35,1.32,1.42,2.3,0,.07,0,.14,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.58,47.17c1.98,1.92,3.16,4.65,3.04,7.63v.02c-.08,1.81-.64,3.51-1.57,4.94-.01,.02-.02,.05-.03,.07-.85,1.31-2.01,2.41-3.36,3.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 27.62,
    y1: 54.82,
    x2: 59.95,
    y2: 54.82
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.51,79.9l6.94-6.94c3.14-3.14,7.39-4.9,11.82-4.9h19.56"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.55,73.29c-.38-.09-.76-.18-1.13-.29-.28-.08-.56-.17-.84-.26C5.98,70.18,.5,63,.5,54.53c0-6.88,3.62-12.91,9.07-16.3,.73-.46,1.48-.86,2.26-1.2,.6-.29,1.22-.52,1.86-.73,1.03-.34,2.1-.6,3.19-.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 82.11,
    cy: 54.82,
    r: 4.73
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtificialIntelligence);
export default __webpack_public_path__ + "static/media/artificial-intelligence.6430ffc83f8adb458c22e9ecd8a27b38.svg";
export { ForwardRef as ReactComponent };